import { Controller } from "@hotwired/stimulus"

/**
 * Billing Address Selector Controller
 * Allows customers to select which billing address to use for credit card payments.
 * Works for both single card and split payment scenarios.
 */
export default class extends Controller {
  static targets = ["select", "preview", "accountAddress"]
  static values = {
    addresses: Array,
    accountAddress: Object
  }

  connect() {
    this.updatePreview()
  }

  change(event) {
    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasPreviewTarget) return

    const selectedValue = this.selectTarget.value

    if (selectedValue === "" || selectedValue === "account") {
      // Show account address
      if (this.hasAccountAddressValue && Object.keys(this.accountAddressValue).length > 0) {
        this.previewTarget.innerHTML = this.formatAddress(this.accountAddressValue)
        this.previewTarget.classList.remove("hidden")
      } else {
        this.previewTarget.classList.add("hidden")
      }
    } else {
      // Show selected billing address
      const address = this.addressesValue.find(a => a.id.toString() === selectedValue)
      if (address) {
        this.previewTarget.innerHTML = this.formatAddress(address)
        this.previewTarget.classList.remove("hidden")
      } else {
        this.previewTarget.classList.add("hidden")
      }
    }
  }

  formatAddress(address) {
    const parts = []

    // Address line
    if (address.address) {
      let line = address.address
      if (address.address_number) line += `, ${address.address_number}`
      if (address.complement) line += ` - ${address.complement}`
      parts.push(line)
    }

    // Neighborhood, City/State
    if (address.neighborhood || address.city || address.state) {
      let line = address.neighborhood || ""
      if (address.city && address.state) {
        line += (line ? " - " : "") + `${address.city}/${address.state}`
      }
      parts.push(line)
    }

    // CEP
    if (address.zipcode) {
      parts.push(`CEP: ${this.formatCep(address.zipcode)}`)
    }

    return `<span class="text-xs text-gray-500">${parts.join(" • ")}</span>`
  }

  formatCep(cep) {
    if (!cep) return ""
    const clean = cep.replace(/\D/g, "")
    if (clean.length === 8) {
      return `${clean.slice(0,5)}-${clean.slice(5)}`
    }
    return cep
  }
}
